<template>
  <div v-if="!bankAccount.postOffice" class="bank ml16 mt20 mr16">
    <div class="bonus_list">
      <div class="bonus_title rb c5a">銀行名</div>
      <div class="bonus_price rb c5a">{{ bankAccount.bank.bankName }}</div>
    </div>
    <div class="bonus_list">
      <div class="bonus_title rb c5a">口座種別</div>
      <div class="bonus_price rb c5a">{{ bankAccount.accountType == 'SAVING'? '普通' : '当座' }}</div>
    </div>
    <div class="bonus_list">
      <div class="bonus_title rb c5a">支店名</div>
      <div class="bonus_price rb c5a">{{ bankAccount.branch.branchName }}</div>
    </div>
    <div class="bonus_list">
      <div class="bonus_title rb c5a">口座番号</div>
      <div class="bonus_price rb c5a">{{ bankAccount.accountNumber }}</div>
    </div>
    <div class="bonus_list" v-if="!isConfirm">
      <div class="bonus_title rb c5a">口座名義人名</div>
      <p class="bonus_price rb c5a">{{ bankAccount.accountName }}</p>
    </div>
  </div>
  <div v-else class="bank ml16 mt20 mr16">
    <div class="bonus_list">
      <div class="bonus_title rb c5a">銀行名</div>
      <div class="bonus_price rb c5a">ゆうちょ銀行</div>
    </div>
    <div class="bonus_list">
      <div class="bonus_title rb c5a">通帳記号</div>
      <div class="bonus_price rb c5a">{{ bankAccount.postOfficeSign }}</div>
    </div>
    <div class="bonus_list">
      <div class="bonus_title rb c5a">通帳番号</div>
      <div class="bonus_price rb c5a">{{ bankAccount.postOfficeNumber }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: ['isConfirm'],
  computed: mapGetters(['bankAccount']),
}
</script>

<style lang="css" scoped>
.bonus_list {
  display: flex;
  justify-content: space-between;
  line-height: 1;
  margin-top: 13px;
}
.bonus_title {
  font-size: 14px;
}
.bank .bonus_price {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/wallet/WithdrawBank.vue